// @flow
import React from 'react';
import Chart from 'react-apexcharts';
import GraphLoader from '../../../../components/GraphLoader';

const HealthOfIPSModelsThroughPFCStepLineChart = ({ data }) => {
    const loading = !data?.length;

    if (loading) {
        return <GraphLoader />;
    }

    const apexLineChartWithLables = {
        chart: {
            animations: { enabled: false },
            height: 364,
            type: 'line',
            dropShadow: { enabled: true, opacity: 0.1, blur: 7, left: -7, top: 7 },
            toolbar: { show: true },
            parentHeightOffset: 0,
        },
        grid: { padding: { left: 0, right: 0 } },
        dataLabels: { enabled: false },
        stroke: { curve: ['stepline'], width: 4 },
        zoom: { enabled: true },
        colors: ['#0acf97', '#fa5c7c', '#ffbc00'],
        xaxis: {
            type: 'datetime',
            labels: { format: 'dd MMM yyyy' },
            tooltip: { enabled: false },
            axisBorder: { show: false },
        },
        yaxis: { type: 'value', min: 0, max: 1, forceNiceScale: true },
    };

    const apexLineChartWithLablesData = [{ name: 'Health Of IPS Models Through PFC', data: data }];

    return (
        <Chart
            options={apexLineChartWithLables}
            series={apexLineChartWithLablesData}
            type="line"
            className="apex-charts mt-3"
            height={378}
        />
    );
};

export default HealthOfIPSModelsThroughPFCStepLineChart;
